enum CallType {
  AUDIO = "audio",
  VIDEO = "video",
}

export default CallType;
